/**
 * 
 * @param {string} sender 
 * @returns 
 */
const subscribe = (node) => (sender) => {
    let subscriptions = node.subscriptions;
    if (!subscriptions) {
        subscriptions = new Set();
    }

    subscriptions.add(sender);
    node.subscriptions = subscriptions;
}

/**
 * 
 * @param {*} node 
 * @returns 
 */
const unsubscribe = (node) => (sender) => {
    let subscriptions = node.subscriptions;
    if (!subscriptions) {
        subscriptions = new Set();
    }

    subscriptions.delete(sender);
    node.subscriptions = subscriptions;
}

export { subscribe, unsubscribe };